import { createHashHistory, createBrowserHistory } from 'history';

const createHistory = (isDxp: boolean) => {
  return isDxp ? createHashHistory() : createBrowserHistory();
};
export default createHistory;
